import {Component, Inject, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {ProleisSuppliersState} from '../../../store/store.index';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {DeliveriesActions, DeliveriesSelectors} from '../../../store/deliveries/deliveries.index';
import {MatRadioChange} from '@angular/material/radio';
import {ActivatedRoute} from '@angular/router';
import {ValidatePboModel} from '../../../../services/suppliers.service';
import {FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {IncidentsActions, IncidentsSelectors} from '../../../store/incidents/incidents.index';
import {Observable} from 'rxjs';
import {APP_GUIDS, AppGuids} from '../../../../app.guids';
import {ProleisObject} from "@proleis/proleis-rest-client";

@Component({
  selector: 'ps-create-planned-delivery-bottomsheet',
  templateUrl: 'create.planned.delivery.component.html'
})
export class CreatePlannedDeliveryComponent implements OnInit {
  formGroup: FormGroup;
  radioSelection: any;
  validatedPboSubtypes: ValidatePboModel[];
  incidents$: Observable<ProleisObject[]>;
  incident: ProleisObject;
  fromIncident: boolean = false;

  constructor(private store: Store<ProleisSuppliersState>,
              private bs: MatBottomSheetRef<CreatePlannedDeliveryComponent>, @Inject(MAT_BOTTOM_SHEET_DATA) public data,
              private route: ActivatedRoute, @Inject(APP_GUIDS) private guids: AppGuids) {
  }

  ngOnInit() {
    this.incident = this.data.incident;
    this.fromIncident = this.data.fromIncident;
    this.initForm();

    this.store.dispatch(DeliveriesActions.VALIDATE_PBO_SUBTYPES({
      pboId: this.data.pboId,
      pseId: this.data.pseId
    }));
    this.store.select(DeliveriesSelectors.SELECT_VALIDATED_PBOS).subscribe(result => {
      this.validatedPboSubtypes = result;
    });

    this.store.dispatch(IncidentsActions.LOAD_INCIDENTS({
      orderId: this.data.pboId,
      posId: this.data.pseId,
      aliasFields: ''
    }));

    this.incidents$ = this.store.select(IncidentsSelectors.selectIncidents);

    if (this.data.fromIncident) {
      this.radioSelection = this.guids.GUID_TYPE_RECEIVE_QS_PARTS;
    }
  }

  initForm() {
    const validatePlannedCount: ValidatorFn = (fg: FormGroup) => {
      const plannedCount = fg.get('plannedCountControl').value;
      const incidentCount = fg.get('deliveryIncident').value?.PARTS_AFFECTED;
      if (incidentCount === 0) {
        return null;
      }

      if (plannedCount > incidentCount) {
        return {
          mismatchedCount: true
        };
      }
      return null;
    };

    this.formGroup = new FormGroup({
      plannedCountControl: new FormControl('', [Validators.required, Validators.min(1)]),
      plannedDateControl: new FormControl('', [Validators.required]),
      deliveryCommentControl: new FormControl(''),
      deliveryIncident: new FormControl(this.incident)
    }, {
      validators: validatePlannedCount,
      updateOn: 'change'
    });

    if (this.fromIncident) {
      this.formGroup.get('deliveryIncident').disable();
    }

    this.formGroup.get('deliveryIncident').valueChanges.subscribe(result => this.incident = result);
  }

  createPlannedDelivery() {
    if (this.formGroup.valid) {
      this.store.dispatch(DeliveriesActions.CREATE_PLANNED_DELIVERY({
        pboId: this.data.pboId,
        posId: this.data.pseId,
        subtypeGuid: this.radioSelection,
        plannedCount: this.formGroup.get('plannedCountControl').value,
        plannedDate: this.formGroup.get('plannedDateControl').value,
        deliveryComment: this.formGroup.get('deliveryCommentControl').value,
        incidentId: this.formGroup.get('deliveryIncident').value?.OBJECT_ID
      }));
      this.bs.dismiss();
    }
  }

  dismiss() {
    this.bs.dismiss();
  }

  onRadioChange(event: MatRadioChange) {
    this.radioSelection = event.value;
  }

  isQsDelivery() {
    return this.guids.GUID_TYPE_RECEIVE_QS_PARTS === this.radioSelection;
  }

  compareIncidents(o1: ProleisObject, o2: ProleisObject) {
    return o1.OBJECT_ID === o2.OBJECT_ID;
  }

}
